import { _ as _sfc_main } from "./VaDivider.vue_vue_type_script_lang-4b90507d.mjs";
import { openBlock, createElementBlock, normalizeClass, normalizeStyle, renderSlot, createCommentVNode } from "vue";
import { _ as _export_sfc } from "../../../plugin-vue_export-helper-cc2b3d55.mjs";
const VaDivider_vue_vue_type_style_index_0_lang = "";
const _hoisted_1 = ["aria-orientation"];
const _hoisted_2 = {
  key: 0,
  class: "va-divider__text"
};
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    role: "separator",
    class: normalizeClass(["va-divider", _ctx.classComputed]),
    "aria-orientation": _ctx.vertical ? "vertical" : "horizontal",
    "aria-hidden": true,
    style: normalizeStyle(`--va-0-color-computed: ${String(_ctx.colorComputed)}`)
  }, [
    _ctx.hasSlot && !_ctx.vertical ? (openBlock(), createElementBlock("div", _hoisted_2, [
      renderSlot(_ctx.$slots, "default")
    ])) : createCommentVNode("", true)
  ], 14, _hoisted_1);
}
const _VaDivider = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  _VaDivider as _
};
//# sourceMappingURL=VaDivider-a83c5ea0.mjs.map
